export const SET_FEATURES = "SET_FEATURES";

export type FeatureFlags = { [key: string]: boolean };

interface SetFeatures {
    type: typeof SET_FEATURES;
    payload: FeatureFlags;
}

export type FeaturesTypes = SetFeatures;
